import { useLang } from "@/context/LanguageContext";

const BG =
  "https://images.unsplash.com/photo-1549791084-5f78368b208b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600";

// Full-page status screen that mirrors the Login layout. Purely static — makes no API calls, so it
// renders even when the tenant backend is unreachable.
export function TenantStatusScreen({ icon: Icon, title, body, hint, tone = "primary", testid, footer }) {
  const { t } = useLang();
  const accent = tone === "amber" ? "text-amber-600" : "text-primary";
  return (
    <div className="grid min-h-screen grid-cols-1 lg:grid-cols-2" data-testid={testid}>
      <div className="flex items-center justify-center bg-white px-5 py-10 sm:px-6 sm:py-12">
        <div className="w-full max-w-sm">
          <div className="mb-10 flex items-center gap-2.5">
            <img src="/logo.svg" alt="Scalio Nexus" className="h-9 w-9 shrink-0" />
            <div className="leading-none">
              <div className="font-display text-base font-black uppercase tracking-tight text-zinc-950">
                Scalio Nexus
              </div>
              <div className="font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-400">
                {t("brand.subtitle")}
              </div>
            </div>
          </div>

          {Icon && (
            <div className={`mb-6 flex h-12 w-12 items-center justify-center rounded-sm bg-zinc-50 ${accent}`}>
              <Icon size={24} strokeWidth={1.75} />
            </div>
          )}

          <h1 className="font-display text-3xl font-black uppercase tracking-tighter text-zinc-950" data-testid="tenant-status-title">
            {title}
          </h1>
          <p className="mt-3 text-sm leading-relaxed text-zinc-600" data-testid="tenant-status-body">{body}</p>
          {hint && <p className="mt-4 text-sm text-zinc-400">{hint}</p>}
          {footer && <div className="mt-8">{footer}</div>}
        </div>
      </div>

      <div className="relative hidden lg:block">
        <img src={BG} alt="" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-primary/85 mix-blend-multiply" />
        <div className="relative flex h-full flex-col justify-end p-12 text-white">
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-white/70">{t("login.tagline")}</div>
          <h2 className="mt-4 max-w-md font-display text-4xl font-black uppercase leading-[1.05] tracking-tighter">
            {t("login.govern")}
          </h2>
          <p className="mt-4 max-w-md text-sm text-white/80">{t("login.description")}</p>
        </div>
      </div>
    </div>
  );
}
